import { Component, OnInit, Input } from '@angular/core';
import { RopeShovelService } from '../../rope-shovel.service';
import { NotificationsService } from 'angular2-notifications';
import { ViewPhotoComponent } from '../view-photo/view-photo.component';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'additional-record-number',
  templateUrl: './additional-record-number.component.html',
  styleUrls: ['./additional-record-number.component.scss']
})
export class AdditionalRecordNumberComponent implements OnInit {
  @Input() id: number = 0;
  @Input() recordId: number = 0;
  @Input() side: string;
  @Input() inspectionId: number;
  label: string = "Record Name";
  text: string = "100";
  loaded: boolean = false;
  image:string;



  constructor(private _service: RopeShovelService,public dialog: MatDialog,private _sanitizer: DomSanitizer,
              private _notify: NotificationsService) { }

  ngOnInit() {
      this._service.getAdditionalRecordDetails(this.recordId, this.id, this.side, this.inspectionId).subscribe(r => {
        this.label = r.Name;
        this.text = r.Data;
        this.image=r.Image;
        this.loaded = true;
      });
  }

  updateRecord(value: string) {
    this._service.updateAdditionalRecord(this.recordId, this.id, this.side, this.inspectionId, value).subscribe(r => {
      console.log("r.m_Item1", r)
      if (r.m_Item1>0) {
        this._notify.success('Saved', r.m_Item2);
        this.loadPhoto();
      } else {
        this._notify.error('Couldn\'t Save', r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.error('Error', 'Failed to save. Please contact TrackTreads support. ');
    });
  }

  viewPhoto() {
    let viewPhotoModalRef = this.dialog.open(ViewPhotoComponent, {
      width: '80%',
      height: '80%',
      data: { photoType: 'additioanl', photoId: this.recordId, img:this.image }
    });
    viewPhotoModalRef.afterClosed().subscribe(r => {
        if ((r.data != null) && (r.data.isDeleted)) {
            this.image = '';
        }
        else {
            this.loadPhoto();
        }
    });
  }

  loadPhoto() {
    if (this.recordId != -1) {
      this._service.getAdditionalRecordDetails(this.recordId, this.id, this.side, this.inspectionId).subscribe(r => {
        this.label = r.Name;
        this.text = r.Data;
        this.image=r.Image;
        this.loaded = true;

      });
    }
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
}
